import { render, staticRenderFns } from "./GradeRuleSlidebar.vue?vue&type=template&id=67f785d5"
import script from "./GradeRuleSlidebar.vue?vue&type=script&lang=js"
export * from "./GradeRuleSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports